import { tv } from 'tailwind-variants';

const chatMessageStyles = tv({
    slots: {
        root: `
        iris:flex
        iris:w-full
        iris:flex-col
        iris:gap-(--comp-space-gap-chat-message)
    `,
        timestamp: `
        aria-hidden:false
        iris:font-(family-name:--comp-type-font-body)
        iris:text-(length:--comp-type-size-body-xs)
        iris:leading-(--comp-type-leading-body-xs)
        iris:whitespace-nowrap
        iris:text-(--comp-color-content-chat-message-timestamp)
        iris:opacity-85
        iris:select-none
    `,
        bubble: `
        iris:relative
        iris:box-border
        iris:flex
        iris:max-w-[min(var(--comp-size-width-chat-message,600px),80%)]
        iris:flex-col
        iris:gap-(--comp-space-gap-chat-message)
        iris:overflow-hidden
        iris:rounded-tl-(--comp-size-radius-chat-message-top-left)
        iris:rounded-tr-(--comp-size-radius-chat-message-top-right)
        iris:rounded-br-(--comp-size-radius-chat-message-bottom-right)
        iris:rounded-bl-(--comp-size-radius-chat-message-bottom-left)
        iris:bg-(--comp-color-background-chat-message-received)
        iris:px-(--comp-space-padding-chat-message-horizontal)
        iris:py-(--comp-space-padding-chat-message-vertical)
        iris:break-words
    `,
        imageContainer: "iris:max-w-[min(var(--comp-size-width-chat-message,600px),80%)]",
        text: "iris:text-(--comp-color-content-chat-message-chat-message)",
        image: `
        iris:rounded-inherit
        select-none
        iris:pointer-events-auto
        iris:block
        iris:h-auto
        iris:max-w-full
        iris:object-cover
    `,
    },
    variants: {
        variant: {
            sent: {
                root: `
            iris:items-end
            iris:text-right
        `,
                bubble: `
            iris:rounded-br-[unset]
            iris:bg-(--comp-color-background-chat-message-sent)
        `,
            },
            received: {
                root: `
            iris:items-start
            iris:text-left
        `,
                bubble: `
            iris:rounded-bl-[unset]
            iris:bg-(--comp-color-background-chat-message-received)
        `,
            },
        },
        inverse: {
            false: {},
            true: {
                timestamp: `
          iris:text-(--comp-color-content-chat-message-timestamp-inverse)
        `,
                text: `
          iris:text-(--comp-color-content-chat-message-chat-message-inverse)
        `,
            },
        },
    },
    compoundVariants: [
        {
            variant: "sent",
            inverse: true,
            class: {
                bubble: "iris:bg-(--comp-color-background-chat-message-sent-inverse)",
            },
        },
        {
            variant: "received",
            inverse: true,
            class: {
                bubble: "iris:bg-(--comp-color-background-chat-message-received-inverse)",
            },
        },
    ],
    defaultVariants: {
        inverse: false,
        size: "md",
    },
});

export { chatMessageStyles as default };
